export enum Language {
	fi = 'fi-FI',
	en = 'en-US',
	swe = 'sv-SE'
}

export enum LanguageId {
	finnish = 0,
	swedish = 1,
	english = 2
}

export const toLanguageId = {
	[Language.fi]: LanguageId.finnish,
	[Language.en]: LanguageId.english,
	[Language.swe]: LanguageId.swedish
};
